import { Box, Typography } from '@mui/material';
import { promoCouponSprite, promoGreenRibbonSrc, promoRedRibbonSrc, promoRewardSprite } from '../../assets/bazzar';

function PromoIconCluster() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 32,
        height: 42,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '11%',
          transform: 'translateX(-50%)',
          width: 26,
          height: 29,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <Box
          component="img"
          src={promoRewardSprite}
          alt=""
          sx={{
            width: '335.37%',
            height: '203.98%',
            maxWidth: 'none',
            display: 'block',
            ml: '-14.85%',
            mt: '-61.16%',
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          bottom: '12%',
          transform: 'translateX(-50%)',
          width: 26,
          height: 20,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <Box
          component="img"
          src={promoCouponSprite}
          alt=""
          sx={{
            width: '112.28%',
            height: '154.45%',
            maxWidth: 'none',
            display: 'block',
            ml: '-7.79%',
            mt: '-26.7%',
          }}
        />
      </Box>
    </Box>
  );
}

export default function PromoStrip({ tone }) {
  const isRed = tone === 'red';
  const headline = isRed ? 'RapFire' : 'RapLeague';
  const amount = isRed ? '1500' : '1200';
  const textWidth = isRed ? 247 : 287;

  return (
    <Box
      sx={{
        position: 'relative',
        width: { xs: '100%', md: '100%' },
        maxWidth: 400,
        height: 54,
        mx: 'auto',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={isRed ? promoRedRibbonSrc : promoGreenRibbonSrc}
        alt={isRed ? 'red promo ribbon' : 'green promo ribbon'}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          display: 'block',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: '0',
          top: '0',
          width: {xs: '100%', md: '100%'},
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <PromoIconCluster />
        <Box
          sx={{
            width: textWidth,
            maxWidth: 'calc(100% - 120px)',
            textAlign: 'center',
          }}
        >
          <Typography
            component="p"
            sx={{
              color: '#fff',
              fontWeight: 500,
              fontSize: {xs: 12,sm: 14, md: 16},
              lineHeight: '22px',
              letterSpacing: '0.8px',
              m: 0,
            }}
          >
            Top #1 {headline} - Win Upto
          </Typography>
          <Typography
            component="p"
            sx={{
              color: '#fff',
              fontWeight: 500,
              fontSize: {xs: 12,sm: 14, md: 16},
              lineHeight: '22px',
              letterSpacing: '0.8px',
              m: 0,
            }}
          >
            ₹ {amount} Coupon Voucher
          </Typography>
        </Box>
        <PromoIconCluster />

        
      </Box>
      
    </Box>
  );
}
